import { IIndustryWithPolicyTypes } from "@/api/industries";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router";

interface Props {
    industry: IIndustryWithPolicyTypes;
}

export const IndustryDetailsButton = ({ industry }: Props) => {
    return (
        <Link
            component={RouterLink}
            to={`/admin/industries/${industry.id}/details`}
            underline="hover"
        >
            {industry.name}
        </Link>
    );
};
